import { BillingInfoSectionSlot as BaseBillingInfoSectionSlot } from "../../common/components";

export const BillingInfoSectionSlot = (props) => {
    return (
        <BaseBillingInfoSectionSlot {...props}>
        </BaseBillingInfoSectionSlot>
    );
};
